
// actionType:
// -- detail
// -- add
// -- remove
// -- purchase
// -- impressions
// -- promoView
// -- promoClick

export default ( props, inject ) => {
  const yandexCommerce = function (actionType, products = [], additionalInformation = {}) {
    // Инициализация dataLayer
    window.dataLayer = window.dataLayer || [];
    // window._tmr = window._tmr || (window._tmr = []);

    // Трансформация товаров
    const formatProduct = _getProducts(products);

    let ecommerce = {
      "currencyCode": "RUB",
      [actionType]: {
        products: formatProduct
      }
    }
    if (actionType === "purchase") {
      ecommerce[actionType]['actionField'] = {
        "id" : additionalInformation?.actionFieldId,
        "goal_id": 18834940
      }
    }
    if (actionType === "impressions") {
      ecommerce = {
        "currencyCode": "RUB",
        impressions: _getProducts(products)
      }
    }
    if (actionType === "promoView" || actionType === "promoClick") {
      ecommerce = {
        [actionType]: {
          "promotions": _getPromotions(products)
        }
      }
    }

    window.dataLayer.push({"ecommerce": ecommerce});
  }

  return inject("yandexCommerce", yandexCommerce)
}

const _getProducts = (products = []) => {
  return products.map(( product ) => {
    if (!product) {
      return {}
    }

    return {
      id: product.id,
      name: product.name,
      brand: product?.brand?.name,
      category: product?.category?.name || product?.category,
      price: product.price || product.newPrice,
      quantity: product.quantity,
      variant: product.modificationId,
    }
  })
}
const _getPromotions = (promotions = []) => {
  return promotions.map((promotion) => {
    return {
      id: promotion?.id,
      name: promotion?.title
    }
  })
}
